function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Handle all Vendor package instatiations
 * (Probably requires jQuery)
 *
 * define & call statically since we dont need
 * to instiatate anything
 */

var useragent = require('ua-parser-js');
import Choices from 'choices.js';
require("magnific-popup");
var _ = require('lodash');
var Vendor = /*#__PURE__*/function () {
  function Vendor() {
    _classCallCheck(this, Vendor);
  }
  return _createClass(Vendor, null, [{
    key: "addUaToBody",
    value: function addUaToBody(ua) {
      var _document$documentEle;
      var uaClasses = [];
      if (!ua.device.type) {
        uaClasses.push('desktop');
      } else {
        uaClasses.push.apply(uaClasses, [_.kebabCase(ua.device.type), _.kebabCase(ua.device.vendor), _.kebabCase(ua.device.model)]);
      }

      // browser
      var browserName = _.kebabCase(ua.browser.name);
      uaClasses.push.apply(uaClasses, [browserName, "".concat(browserName, "-").concat(ua.browser.major)]);
      (_document$documentEle = document.documentElement.classList).add.apply(_document$documentEle, uaClasses);
    }

    // wordpress image block lightbox
  }, {
    key: "wpImageBlockModals",
    value: function wpImageBlockModals() {
      $('.wp-block-image').each(function () {
        $(this).magnificPopup({
          type: 'image',
          delegate: 'a',
          removalDelay: 250,
          image: {
            titleSrc: function titleSrc(item) {
              return item.el.next('figcaption').text();
            }
          },
          // just fade in/out
          // mainClass: 'mfp-fade',
          // or zoomed
          mainClass: 'mfp-zoom',
          zoom: {
            enabled: true,
            duration: 250,
            easing: 'ease-in-out',
            opener: function opener(openerEl) {
              return openerEl.is('img') ? openerEl : openerEl.find('img');
            }
          }
        });
      });
    }

    // wordpress gallery block lightbox
  }, {
    key: "wpGalleryBlockModals",
    value: function wpGalleryBlockModals() {
      $('.wp-block-gallery').each(function () {
        $(this).magnificPopup({
          type: 'image',
          delegate: 'a',
          removalDelay: 250,
          image: {
            titleSrc: function titleSrc(item) {
              return item.el.next('figcaption').text();
            }
          },
          gallery: {
            enabled: true
          },
          // just fade in/out
          // mainClass: 'mfp-fade',
          // or zoomed
          mainClass: 'mfp-zoom',
          zoom: {
            enabled: true,
            duration: 250,
            easing: 'ease-in-out',
            opener: function opener(openerEl) {
              return openerEl.is('img') ? openerEl : openerEl.find('img');
            }
          }
        });
      });
    }

    // pretty select dropdowns
  }, {
    key: "choices",
    value: function choices() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'select';
      var selects = document.getElementsByTagName(selector);
      if (selects.length == 0) return false;
      new Choices(selects, {
        shouldSort: false,
        itemSelectText: '',
        searchEnabled: false,
        //searchPlaceholderValue: 'Search options...',
        removeItemButton: true
      });
    }

    // default mfp modals
  }, {
    key: "modalPopups",
    value: function modalPopups() {
      // video urls work here too
      // button w/ youtube?
      jQuery('.popup--iframe').magnificPopup({
        type: 'iframe',
        removalDelay: 250,
        mainClass: 'mfp-fade',
        patterns: {
          youtube: {
            index: 'youtube.com/',
            id: 'v=',
            src: '//www.youtube.com/embed/%id%?autoplay=1'
          },
          vimeo: {
            index: 'vimeo.com/',
            id: '/',
            src: '//player.vimeo.com/video/%id%?autoplay=1'
          }
        }
      });
      jQuery('.popup--image').magnificPopup({
        type: 'image',
        removalDelay: 250,
        mainClass: 'mfp-fade'
      });
      jQuery('.popup--inline').magnificPopup({
        type: 'inline',
        removalDelay: 250,
        mainClass: 'mfp-fade'
      });
    }

    // default carousel
  }, {
    key: "carousel",
    value: function carousel() {
      jQuery('.owl-carousel').owlCarousel({
        autoplay: true,
        autoplayTimeout: 5000,
        autoplaySpeed: 550,
        slideTransition: 'linear',
        items: 1,
        loop: true,
        dots: true,
        nav: true,
        navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']
      });
    }

    // sticky head that shows on scroll
  }, {
    key: "headroom",
    value: function headroom() {
      var banner = document.getElementById('banner');
      if (window.location.hash) {
        banner.classList.add("headroom--unpinned");
      }
      var headroom = new Headroom(banner, {
        offset: 90 // body padding and banner height
      });
      headroom.init();
    }
  }, {
    key: "countUpJS",
    value: function countUpJS() {
      var counters = Array.from(document.querySelectorAll('[data-countup]'));
      if (!counters || counters.lenght === 0) return;
      var reg = /(^\D*?)(\d*\.?\,?\d*?)(\D*?$)/;
      var decReg = /(\d+)(\.)(\d+)/;
      var commaReg = /\,/;

      // parseFloat(val).toFixed(3)

      counters.forEach(function (counter) {
        var matched = counter.dataset.countup.match(reg);
        var decimaled = matched[2].match(decReg);
        var commaed = matched[2].match(commaReg);
        var num = matched[2];
        var places = 0;
        if (commaed) {
          num = num.replace(',', '');
        }
        if (decimaled) {
          places = decimaled[3].length;
        }
        new CountUp(counter, num, {
          decimalPlaces: places,
          startVal: 0,
          prefix: matched[1],
          suffix: matched[3]
        }).start();
      });
    }
  }]);
}();
export { Vendor as default };